<template>
  <div :style="cssVariables">
    <div class="onePickMore-title">
      <div>
        <i style="font-size: 15px" class="el-icon-s-order"></i>
        {{ title }}分组样本信息
      </div>
<!--      <div style="font-size: 14px;">共{{ showData.length }}个分组</div>-->
    </div>
    <div class="onePickMore-container">
      <div class="inputDiv">
        <el-input size="small" clearable :placeholder="'搜索'+title+'分组/样本'"
                  prefix-icon="el-icon-search" v-model="SearchValue"></el-input>
      </div>
      <group-sample :group-list="filteredData"></group-sample>

    </div>
  </div>
</template>

<script>

import GroupSample from "@/components/project/transMetabo/groupSample.vue";

export default {
  name: 'onePickMore',
  components: { GroupSample },
  props: {
    title: {
      type: String,
      default: ''
    },
    showData: {
      type: Array,
      default: () => []
    },
    descriptionsStyle: {
      type: Object
    }
  },
  data () {
    return {
      SearchValue: '',
    }
  },
  computed: {
    filteredData () {
      return this.filterBySearch(this.showData, this.SearchValue)
    },
    cssVariables () {
      const style = this.descriptionsStyle
      return {
        '--label-background-color': style?.labelBackgroundColor,
        '--lable-color': style?.groupLableColor
      }
    }
  },
  methods: {
    /**
     * 根据关键词过滤数据（匹配 content 字段）
     * @param {Array}  data    - 待过滤的数据
     * @param {string} keyword - 搜索关键词
     * @returns {Array}
     */
    filterBySearch (data, keyword) {
      if (!keyword) return data
      let filteredData = data.filter(item => {
        // 分组名
        if (item.groupName?.includes(keyword)) {
          return true
        }
        // 样本名
        if (item.sampleList) {
          if (item.sampleList.join(',').includes(keyword)) {
            return true
          }
        }

      })
      return filteredData
    },
  }
}


</script>
<style scoped>
.onePickMore-title {
  font-size: 15px;
  padding: 12px 16px;
  font-weight: 600;
  width: 100%;
  color: var(--lable-color, #63b59f) !important;
  background-color: var(--label-background-color, #f8f9fa) !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.onePickMore-container {
  padding: 0 16px 16px;
}

/* 搜索框容器 */
.inputDiv {
  margin: 12px 0 16px;
  width: 100%;
}

/* 搜索框样式优化 */
/deep/ .inputDiv .el-input .el-input__inner {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

/deep/ .inputDiv .el-input .el-input__inner:focus {
  border-color: #5fC1C9;
}

/* 搜索图标颜色 */
/deep/ .inputDiv .el-input .el-icon-search {
  color: #6b7280 !important;
}

.onePickMore-list {
  margin: 10px 0;
  max-height: calc(100vh - 320px);
  overflow-y: auto;
}

/* 滚动条样式 */
.onePickMore-list::-webkit-scrollbar {
  width: 6px;
}

.onePickMore-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.onePickMore-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.onePickMore-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
